import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	onlyTitleMatch: {
		id: 'dynamic-cards-search-page.filters.names.titleMatchOnly',
		defaultMessage: 'Title match',
		description: 'Label for filtering by exact title match',
	},
});
